
import { Options, Vue } from "vue-class-component";
import { DashboardController } from "@/app/ui/controllers/DashboardController";
import AllStt from "./all-stt/index.vue";
import CurrentStt from "./current-stt/index.vue";
import HangingIncoming from "./hanging/tab-hanging-incoming/index.vue";
import HangingLastMile from "./hanging/tab-hanging-last-mile/index.vue";
import TabHangingOutgoing from "./hanging/tab-hanging-outgoing/index.vue";
import TabHangingBkd from "./hanging/tab-hanging-bkd/index.vue";
import CodDashboard from "@/app/ui/views/dashboard/cod-dashboard/index.vue";
import { FlagsDashboardCod } from "@/feature-flags/dashboard/cod";
import { FcsPermissionSttHanging } from "@/feature-flags/flags-permission-stt-hanging";
import { FlagsDashboardConsole } from "@/feature-flags/dashboard/console";
import PerformaIframe from "./PerformaIframe.vue";

@Options({
  components: {
    AllStt,
    CurrentStt,
    CodDashboard,
    HangingIncoming,
    HangingLastMile,
    TabHangingOutgoing,
    TabHangingBkd,
    PerformaIframe
  }
})
class DashboardTabs extends Vue {
  get activeMenu() {
    return DashboardController.activeMenuTabs.main;
  }
  onChangeConsoleTabs(value: string) {
    DashboardController.setActiveMenuTabs({ main: value });
    this.$router.push({ path: "/dashboard", query: { activeMenu: value } });
  }
  created() {
    const defaultTab = this.tabs.length > 0 ? this.tabs[0].value : "all-stt";
    DashboardController.setActiveMenuTabs({
      main: defaultTab,
      child: "outgoing"
    });
  }

  mounted() {
    const activeMenu = "pengumuman";
    const isValidTab = this.tabs.some((tab) => tab.value === activeMenu);
    const fallbackTab = this.tabs.length > 0 ? this.tabs[0].value : "all-stt";
    const main = isValidTab ? activeMenu : fallbackTab;

    DashboardController.setActiveMenuTabs({ main });
    this.$router.push({
      path: "/dashboard",
      query: isValidTab ? { activeMenu } : undefined
    });
  }

  get tabs() {
    const tempTabs = [
      {
        value: "all-stt",
        title: this.$t("dashboard.console.tabs.allStt")
      }
    ];

    if (FlagsDashboardConsole.dashboard_console_current_stt.isEnabled()) {
      tempTabs.push({
        value: "current-stt",
        title: this.$t("dashboard.console.tabs.currentStt")
      });
    }

    if (FlagsDashboardConsole.dashboard_console_performa_iframe.isEnabled()) {
      tempTabs.push({
        value: "performa",
        title: "dashboard.console.tabs.performance"
      });
    }

    if (FlagsDashboardCod.permission_show_tab_cod_dashboard.isEnabled()) {
      tempTabs.push({
        value: "cod-dashboard",
        title: this.$t("dashboard.console.tabs.cod")
      });
    }

    if (
      FcsPermissionSttHanging.permission_hanging_bkd_console_enable.isEnabled()
    ) {
      tempTabs.push({
        value: "hanging-bkd",
        title: this.$t("dashboard.console.tabs.hangingBkd")
      });
    }

    if (
      FcsPermissionSttHanging.permission_hanging_outgoing_enable.isEnabled()
    ) {
      tempTabs.push({
        value: "hanging-outgoing",
        title: this.$t("dashboard.console.tabs.hangingOutgoing")
      });
    }

    if (
      FcsPermissionSttHanging.permission_hanging_incoming_enable.isEnabled()
    ) {
      tempTabs.push({
        value: "hanging-incoming",
        title: this.$t("dashboard.console.tabs.hangingIncoming")
      });
    }

    if (
      FcsPermissionSttHanging.permission_hanging_last_mile_enable.isEnabled()
    ) {
      tempTabs.push({
        value: "hanging-last-mile",
        title: this.$t("dashboard.console.tabs.hangingLastMile")
      });
    }

    return tempTabs;
  }
}

export default DashboardTabs;
